// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"743":"5a651556","794":"792e4e10"}[chunkId] + ".chunk.css";
};